import styled, { css } from 'styled-components';

export const AppBarItem = styled.div<{
  borderRight?: boolean;
  borderLeft?: boolean;
  align?: 'left' | 'right';
}>`
  height: 100%;
  padding: 0 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text.primary};
  order: 1;

  ${({ borderLeft, theme }) =>
    borderLeft &&
    css`
      border-left: 1px solid ${theme.colors.outline.primary};
    `};

  ${({ borderRight, theme }) =>
    borderRight &&
    css`
      border-right: 1px solid ${theme.colors.outline.primary};
    `};

  ${({ align }) =>
    align === 'right' &&
    css`
      order: 3;
    `};
`;
